import { createFormAction } from 'redux-form-saga'
export const FORM_KEY = 'CUSTOMER_INFORMATION_SHEET_FORM'
export const CustomerInformationSheetFormAction = createFormAction(FORM_KEY)